import { useLocalStorage } from '@mantine/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { STORAGE_KEYS } from 'consts';

import { setRefreshToken } from 'helpers';
import { useCallback } from 'react';

export const useClearLoginData = () => {
  const queryClient = useQueryClient();
  const [, setToken] = useLocalStorage({
    key: STORAGE_KEYS.token,
  });

  return useCallback(() => {
    setToken('null');
    setRefreshToken('null');
    sessionStorage?.clear();
    queryClient.clear();
  }, [queryClient, setToken]);
};
